export default __webpack_public_path__ + "static/favicon-32x32-7ee3635b9ee83018f4d8d9600f760b6d.ico";